<template>
  <span> - <a :href="href" target="_blank">{{ label }}</a></span>
</template>

<script>
  export default {
    name: "LiveSaleRef",
    props: {
      href: {
        type: String,
        required: false,
        default: ''
      },
      label: {
        type: String,
        default: ''
      }
    }
  }
</script>
